import { useContext } from "react";
import { LoginContext } from "../../../../contexts/LoginContext/LoginContext";

export default function useStaffRole() {
  return useContext(LoginContext).state.staff?.role;
}